import React, { PropsWithChildren } from 'react';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { ButtonTertiary, ValidationLevel } from 'ui';
import { SavedReportsTranslation } from '../../constants';
import { GenericSavedReport, SavedReportValidation } from '../../types-store';

import styles from './saved-report-details-button.scss';

interface SavedReportDetailsButtonProps<SavedReport extends GenericSavedReport> {
  active: boolean;
  onShowDetails: () => void;
  onHideDetails: () => void;
  validation: SavedReportValidation<SavedReport>;
  translation: SavedReportsTranslation;
}

export const SavedReportDetailsButton = <SavedReport extends GenericSavedReport>({
  active, onShowDetails, onHideDetails, validation, translation
}: PropsWithChildren<SavedReportDetailsButtonProps<SavedReport>>) => {
  const childrenHasErrors = Object.values(validation ?? {})
    .some(v => v.level === ValidationLevel.error);

  const childrenHasWarnings = Object.values(validation ?? {})
    .some(v => v.level === ValidationLevel.warning);

  const validationClass = childrenHasErrors
    ? styles.hasChildErrors
    : (childrenHasWarnings ? styles.hasChildWarnings : '');

  return <div className={styles.buttonContainer}>
    <ButtonTertiary
      classNames={`${styles.detailsButton} ${validationClass}`}
      onClick={active ? onHideDetails : onShowDetails}>
      {active
        ? <>{translation.hide_details}<MdExpandLess /></>
        : <>{translation.show_details}<MdExpandMore /></>
      }
    </ButtonTertiary>
  </div>;
};
